// When 'value' is optional/undefined, the function returns true.
// When 'value' is provided and truthy, it checks for inclusion.
function matchFilterArrayIncludes<T>(array: Array<T>, value?: T | null | ''): boolean

function matchFilterArrayIncludes<T>(array: Array<T> | null | undefined, value?: T | null | ''): boolean {
  if (!array) {
    return false
  }

  if (value) {
    return array.includes(value)
  }

  return true
}

export default matchFilterArrayIncludes